import CardsScroll from "shared/ui/slider/cards-scroll/ui"

import styles from './styles.module.scss';
import Card from "shared/ui/slider/card/ui";

import { IconCertificate, IconCode1, IconCommunity, IconInfrastructure, IconPractice } from "./icons";

export const Slider = () => {

    return (
        <div className={styles.slider} id="get">
            <div className={styles.__in}>

                <div className={styles.title}>
                    Что мы предлагаем
                </div>

                <CardsScroll wCard={360}>
                    <Card key='id1'>
                        <div className={styles.box}>
                            <div className={styles.icon}>
                                <IconInfrastructure width={74} height={74} />
                            </div>
                            <div className={styles.name}>
                                Образовательная платформа
                            </div>
                            <div className={styles.description}>
                                Разработали собственную LMS-систему "Ансариум" с личными кабинетами, интерактивными уроками, проверкой домашних заданий и аналитикой прогресса. Полноценная платформа для онлайн и оффлайн обучения.
                            </div>
                        </div>
                    </Card>
                    <Card key='id2'>
                        <div className={styles.box}>
                            <div className={styles.icon}>
                                <IconCode1 width={74} height={74} />
                            </div>
                            <div className={styles.name}>
                                Современный стек технологий
                            </div>
                            <div className={styles.description}>
                                Работаем с передовыми технологиями: React, TypeScript, Python, PostgreSQL. Используем современные подходы к разработке, микросервисную архитектуру и облачные решения для создания масштабируемых приложений.
                            </div>
                        </div>
                    </Card>
                    <Card key='id3'>
                        <div className={styles.box}>
                            <div className={styles.icon}>
                                <IconPractice width={74} height={74} />
                            </div>
                            <div className={styles.name}>
                                AI и ML решения
                            </div>
                            <div className={styles.description}>
                                Разрабатываем решения с искусственным интеллектом: AI-ассистенты для обучения, автоматическая проверка кода, генерация заданий и персонализированные рекомендации на базе машинного обучения.
                            </div>
                        </div>
                    </Card>
                    <Card key='id4'>
                        <div className={styles.box}>
                            <div className={styles.icon}>
                                <IconCommunity width={74} height={74} />
                            </div>
                            <div className={styles.name}>
                                Комплексный подход
                            </div>
                            <div className={styles.description}>
                                От идеи до реализации: проектирование архитектуры, разработка frontend и backend, настройка баз данных PostgreSQL, развертывание и поддержка. Создаем решения под ключ.
                            </div>
                        </div>
                    </Card>
                    <Card key='id5'>
                        <div className={styles.box}>
                            <div className={styles.icon}>
                                <IconCertificate width={74} height={74} />
                            </div>
                            <div className={styles.name}>
                                Экспертиза в образовании
                            </div>
                            <div className={styles.description}>
                                Не только разрабатываем IT-решения, но и обучаем программированию. Это дает нам уникальное понимание потребностей образовательных проектов и помогает создавать эффективные платформы для обучения.
                            </div>
                        </div>
                    </Card>
                </CardsScroll>
            </div>
        </div>
    )
}